import React, { useEffect, useState } from "react";

const CommonFooter = () => {

  // ✅ 호스트네임에 따라 문구 변경
  const root = document.documentElement;
  const [companyInfo, setCompanyInfo] = useState("");
  const [copyRightInfo, setCopyRight] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const hostname = window.location.hostname;
    
    if (hostname.includes("gnbsoftec.co.kr")) {
        setCompanyInfo("(주)지앤비소프텍   대표이사 : 차호열   E-mail : cha@gnbsoftec.co.kr");
        setCopyRight("COPYRIGHT © 2005 GNBSOFTEC CO., LTD. ALL RIGHTS RESERVED.");
        root.style.setProperty("--footerlogo-url", 'url("/asset/img/common/logo_c.svg")');
    } else if (hostname.includes("puresolution.co.kr")) {
        setCompanyInfo("(주)퓨어솔루션 대표이사 : 차호열 E-mail : cha@gnbsoftec.co.kr");
        setCopyRight("COPYRIGHT © 2013 PURE SOLUTION. ALL RIGHT RESERVED.");
        root.style.setProperty("--footerlogo-url", 'url("/asset/pure/img/common/logo_c.png")');
    } else {
        setCompanyInfo("(주)퓨어솔루션 대표이사 : 차호열 E-mail : cha@gnbsoftec.co.kr");
        setCopyRight("COPYRIGHT © 2013 PURE SOLUTION. ALL RIGHT RESERVED.");
        root.style.setProperty("--footerlogo-url", 'url("/asset/pure/img/common/logo_c.png")');
    }
  }, []);

  return (
    <footer className="footer">
      <div className="inner fnt-ars">
        <h1><a href="/">지앤비소프텍</a></h1>
        <ul>
          <li><a href="/GNBPURE05001S">개인정보처리방침</a></li>
          <li><a href="/GNBPURE05002S">이용약관</a></li>
          <li><a href="/GNBPURE05003S">이메일무단수집공고</a></li>
        </ul>
        <p>고객센터 : <a href="tel:02-3664-7014">02-3664-7014</a></p>
      </div>
      <div className="fnt-info">
          <div className="inner">
            <div className="foot-copyright" style={{textAlign: "left"}}>
              <p>서울특별시 서초구 매헌로 16 하이브랜드몰 1519호   전화 : 02-3664-7014</p>
              <p>{companyInfo}</p>
              <p>{copyRightInfo}</p>
            </div>
            <div className="family">
              <a href="#" onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen); }}>패밀리사이트2</a>
              <ul style={{ display: isOpen ? "block" : "none" }}>
                <li>
                  <a href="http://www.fsb.or.kr/" target="_blank" rel="noopener noreferrer" title="새창열림">저축은행중앙회</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </footer>
  );
};

export default CommonFooter;